export default "__VITE_ASSET__DdYDagmv__"